import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_user_credits_limit_update_status } from '@/state/workspace/user/remote_workspace_user_credits_limit_update_status';
import { RequestWorkspaceUserCreditsLimitUpdateStatus } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_update_status';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useState } from 'react';

interface Props {
  user: DTO__workspace_user;
}

export function WSTableUserCreditLimitCheckbox({ user }: Props) {
  const dispatch = use_dispatch();

  const [inProgress, setInProgress] = useState(false);

  const [isChecked, setIsChecked] = useState(user.credits_limit_enabled);

  async function onCheckedChange() {
    setIsChecked(!isChecked);

    let request = new RequestWorkspaceUserCreditsLimitUpdateStatus();
    request.target_user_id = user.user_id;
    request.is_enabled = !isChecked;
    request.workspace_id = user.workspace_id;

    setInProgress(true);
    await dispatch(remote_workspace_user_credits_limit_update_status(request));
    setInProgress(false);
  }

  function is_disabled(): boolean {
    return inProgress;
  }

  return <UI_PRIMITIVE__checkbox disabled={is_disabled()} id={user._id} checked={isChecked} onCheckedChange={onCheckedChange} />;
}
